<template>
    <div>
        <button type="button" class="btn btn-outline-success btn-sm btn-excel font-weight-bold mb-2" style="width: 100%" @click="tablegenerator()"> 
            <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            Relação de Leitos
        </button>

        <table id="table-export" style="display: none;">
            <tr>
                <td style="font-weight: bold; text-align:center;" colspan="16">​SISREG - RELAÇÂO DOS LEITOS HOSPITALARES EM {{date}}</td>
            </tr>
            <tr>
                <td style="font-weight: bold; text-align:center;" colspan="16">{{unidade.cnes}} - {{unidade.nome}}</td>
            </tr>
            <tr style="background-color: #006e95; color: white; text-align:center;">
                <td>NUM ENF</td>
                <td>LEITO</td> 
                <td>NOME ENFERMARIA</td>
                <td>STATUS</td>
                <td>AIH GERADA PARA O PACIENTE</td>
                <td>NÚMERO DO CNS DO PACIENTE</td>
                <td>NOME PACIENTE</td>
                <td>NOME PACIENTE SOCIAL</td>
                <td>SEXO</td>
                <td>DATA NASC</td>
                <td>IDADE</td>
                <td>DATA INTERN</td>
                <td>MOTIVO IMPEDIMENTO</td>
                <td>DATA IMPEDIMENTO</td>
                <td>CNS DE LEITO RESERVADO</td>
                <td>NOME PACIENTE RESERVADO</td>
                <td>DATA SOL. RESERVA</td>
                <td>PREVISÃO INTERN. RESERVA</td>
            </tr>
            <tr v-for="(item, index) in items" :key="index">
                <td style="text-align: center;">{{item.leitoCodigoEnfermaria}}</td>
                <td style="text-align: center;">{{item.leitoCodigo}}</td>
                <td style="text-align: center;">{{item.leitoNomeEnfermaria}}</td>

                <td v-if="item.leitoStatus == 0" style="text-align: center; background-color: #4fac68; color: white;">LIVRE</td>
                <td v-if="item.leitoStatus == 1" style="text-align: center;">OCUPADO</td>
                <td v-if="item.leitoStatus == 2" style="text-align: center; background-color: #de3341; color: white;">IMPEDIDO</td>
                <td v-if="item.leitoStatus == 3 || item.leitoStatus == 4" style="text-align: center; background-color: #00a2b9; color: white;">CEDIDO</td>
                <td v-if="item.leitoStatus == 5" style="text-align: center; background-color: #e68515; color: white;">RESERVADO</td>

                <td v-if="!item.aih" style="text-align: center;"></td>
                <td v-if="item.aih && item.leitoStatus == 1" style="text-align: center;">="{{item.aih[0].numeroAih}}"</td>

                <td style="text-align: center;">
                    <div v-if="item.leitoStatus == 1">="{{item.pacienteCns}}"&#9;</div>
                </td>

                <td style="text-align: left;">
                    <span v-if="item.leitoStatus == 1">{{item.pacienteNome}}</span>
                </td>

                <td style="text-align: left;">
                    <span v-if="item.leitoStatus == 1">{{item.pacienteNomeSocial}}</span>
                </td>

                <td style="text-align: center;">
                    <span v-if="item.pacienteSexo == '1' && item.leitoStatus == 1">M</span>
                    <span v-if="item.pacienteSexo == '2' && item.leitoStatus == 1">F</span>
                </td>

                <td style="text-align: center;">
                   <span v-if="item.leitoStatus == 1">{{item.pacienteDataNascimento}}</span>
                </td>
                <td style="text-align: center;">
                    <span v-if="item.leitoStatus == 1">{{item.pacienteIdade}}</span>
                </td>
                <td style="text-align: center;">
                    <span v-if="item.leitoStatus == 1">{{item.DataHoraInternacao}}</span>
                </td>
                <td style="text-align: center;">
                    <span v-if="item.leitoStatus == 2">{{item.motivoImpedimento}}</span>
                </td>
                <td style="text-align: center;">
                    <span v-if="item.leitoStatus == 2">{{item.dataHoraImpedimento}}</span>
                </td>
                <td style="text-align: center;">
                    <span v-if="item.leitoStatus == 5">="{{item.cnsPacienteReserva}}"&#9;</span>
                </td>
                <td style="text-align: center;">
                    <span v-if="item.leitoStatus == 5">{{item.nomePacienteReserva}}</span>
                </td>
                 <td style="text-align: center;">
                    <span v-if="item.leitoStatus == 5">{{item.dataHoraReservaSolicitacao}}</span>
                </td>
                <td style="text-align: center;">
                    <span v-if="item.leitoStatus == 5">{{item.dataHoraReserva}}</span>
                </td>
            </tr>

        </table>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
        },
        unidade: {
            type: Object
        }
    },
    computed: {
        date () {
            let dia = new Date().getDate()
            let mes = new Date().getMonth() + 1
            let ano = new Date().getFullYear()
            let hora = new Date().getHours()
            let minutos = new Date().getMinutes()

            if (dia.toString().length == 1) dia = '0' + dia;
            if (mes.toString().length == 1) mes = '0' + mes;
            if (minutos.toString().length == 1) minutos = '0' + minutos;
            if (hora.toString().length == 1) hora = '0' + hora;

            return `${dia}/${mes}/${ano} ${hora}:${minutos}`
        }
    },
    methods: {
    tablegenerator () {
        let filename = 'RelacaoLeitos' + '.xls'
        this.exportExcel('RelacaoLeitos', filename)
    },
    exportExcel (name, filename) {

      let uri = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,',
              template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><title></title><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'

      let base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
      let format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; })}

      let table = document.getElementById("table-export")
      let inner = table.innerHTML

      var ctx = {worksheet: name || 'Worksheet', table: inner}


      var link = document.createElement('a')
      link.download = filename
      link.href = uri + base64(format(template, ctx))
      link.click()

    }
  }
}
</script>

<style>
#table-export td {
    border: 1px solid black;
}
</style>
